export const GUIDE_STEPS = {
  koreanText: [
    {
      title: '1. 세관 방문',
      description: '이 영수증과 구매한 물품을 세관 직원에게 보여주고 도장을 받으세요.',
    },
    {
      title: '2. 환급유인창구 방문',
      description:
        '환급창구에 방문하여 도장받은 영수증을 제시 후 환급금을 받으세요.',
    },
  ],
  englishText: [
    {
      title: '1. Visit Customs',
      description:
        'Show the Tax Refund receipt and your items to customs and get the receipt stamped.',
    },
    {
      title: '2. Visit Refund Counter',
      description:
        'Visit the refund counter, present the stamped receipt and receive refund.',
    },
  ],
  qrGuideText: {
    title: '환급 건 및 세관 위치 확인',
    description:
      'You can scan the QR code to check your refund and the customs location.',
  },
};
